// import { useDispatch } from "react-redux";
// import { useTranslation } from "react-i18next";
// import TabBackUpButton from "../../components/buttons/TabBackUpButton";
// import { refreshTab } from "../../features/tabs/tabSlice";
// import PartnerApi from "../../helpers/PartnerApi";
// import { error as toastError } from "../../features/toast/toastSlice";

// const EditButtonBackUp = ({ data, ...props }) => {
//   const dispatch = useDispatch();
//   const { t } = useTranslation();

//   const onEditBackUpClick = async () => {
//     if (!data?.licenseNo) return;

//     const licenseNo = data.licenseNo;
//     try {
//       const list = await PartnerApi.getLicenseBackupLogList(licenseNo);
//       const hasData = Array.isArray(list) && list.length > 0;

//       if (!hasData) {
//         dispatch(
//           toastError({
//             title: "Info",
//             message: `${t("No backup log data for")} ${licenseNo}.`,
//             delay: 6000,
//           })
//         );
//         return;
//       }
//       dispatch(
//         refreshTab({
//           id: `licenseBackupLogList-${licenseNo}`,
//           title: t("BackUp"),
//           component: "components/buttons/backUp/LicenseBackUpTableTab",
//           tabIcon: "ConnectionIcon",
//           componentProps: { licenseNo },
//         })
//       );
//     } catch (err) {
//       const msg =
//         err?.response?.data?.error?.message ||
//         err?.message ||
//         t("Backup log list fetch failed.");
//       dispatch(
//         toastError({
//           title: "Info",
//           message: msg,
//           delay: 6000,
//         })
//       );
//     }
//   };

//   return (
//     <TabBackUpButton
//       {...props}
//       onClick={onEditBackUpClick}
//       tooltip={t("BackUp")}
//       aria-label={t("BackUp")}
//     />
//   );
// };

// export default EditButtonBackUp;

import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import TabBackUpButton from "../../components/buttons/TabBackUpButton";
import { refreshTab } from "../../features/tabs/tabSlice";
import PartnerApi from "../../helpers/PartnerApi";
import { info as toastInfo, error as toastError } from "../../features/toast/toastSlice";

const EditButtonBackUp = ({ data, ...props }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const onEditBackUpClick = async () => {
    if (!data?.licenseNo) return;

    const licenseNo = data.licenseNo;
    try {
      const list = await PartnerApi.getLicenseBackupLogList(licenseNo);
      const hasData = Array.isArray(list) && list.length > 0;

      if (!hasData) {
        dispatch(
          toastInfo({
            title: t("Info"),
            message: `${t("No backup log data for")} ${licenseNo}.`,
            delay: 6000,
          })
        );
        return;
      }

      dispatch(
        refreshTab({
          id: `licenseBackupLogList-${licenseNo}`,
          title: t("BackUp"),
          component: "components/buttons/backUp/LicenseBackUpTableTab",
          tabIcon: "ConnectionIcon",
          componentProps: { licenseNo },
        })
      );
    } catch (err) {
      const msg =
        err?.response?.data?.error?.message ||
        err?.message ||
        t("Backup log list fetch failed.");

      dispatch(
        toastError({
          title: t("Error"),
          message: msg,
          delay: 6000,
        })
      );
    }
  };

  return (
    <TabBackUpButton
      {...props}
      onClick={onEditBackUpClick}
      tooltip={t("BackUp")}
      aria-label={t("BackUp")}
    />
  );
};

export default EditButtonBackUp;
